// This is temp fix for types while we are updating the different packages
// should be reevaluated once everything in at latest.
import React from 'react'
import {
  Checkbox as FormikCheckbox,
  DatePicker as FormikDatePicker,
  Form as FormikForm,
  FormItem as FormikFormItem,
  Input as FormikInput,
  Select as FormikSelect,
  SubmitButton as FormikSubmitButton,
  Switch as FormikSwitch,
} from 'formik-antd'

export const Form = FormikForm as React.ComponentType<any>
export const FormItem = FormikFormItem as React.ComponentType<any>
export const Switch = FormikSwitch as React.ComponentType<any>
export const SubmitButton = FormikSubmitButton as React.ComponentType<any>
export const Input = FormikInput as React.ComponentType<any>
export const DatePicker = FormikDatePicker as React.ComponentType<any>

export const Select = FormikSelect as React.ComponentType<any> & {
  Option: any
  OptGroup: any
}
Select.Option = (FormikSelect as any).Option
Select.OptGroup = (FormikSelect as any).OptGroup

export const Checkbox = FormikCheckbox as React.ComponentType<any> & {
  Group: React.ComponentType<any>
}
Checkbox.Group = (FormikCheckbox as any).Group
